import { IndividualConfig } from 'ngx-toastr';

type ToastrTypeConfig = Record<string, Partial<IndividualConfig>>;

export const TOASTR_TYPE_CONFIG: ToastrTypeConfig = {
  error: {
    disableTimeOut: 'timeOut',
  },
};
